export class RequestError extends Error {
  constructor(response, url) {
    super(`Bad server response [${response.status}]`);

    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, RequestError);
    }
    this.status = response.status;
    this.data = response.data;
    this.headers = response.headers;
    this.url = url;
  }
}

export class NoConnectionError extends Error {
  constructor() {
    super('Connection to the server failed');
    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, NoConnectionError);
    }
  }
}
